import { apiSlice } from '../../api/apiSlice';
import parseSseConversationResponse from '../../utils/parseSseConversationResponse';

export const chatbotApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveConversation: builder.mutation({
      query: () => ({
        url: 'AiChatbot/Conversations/ActiveConversation',
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getActiveConversationId: builder.mutation({
      query: () => ({
        url: 'AiChatbot/Conversations/ActiveConversationId',
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getMessages: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.id}/Messages`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    createConversation: builder.mutation({
      query: () => ({
        url: 'AiChatbot/Conversations/Create',
        method: 'POST'
      }),
      extraOptions: { showGlobalError: true }
    }),
    addMessageToConversation: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.conversationId}/Messages`,
        method: 'POST',
        body: option,
        responseHandler: async (response) => response.text()
      }),
      transformResponse: (responseText) => parseSseConversationResponse(responseText),
      extraOptions: { showGlobalError: true }
    }),
    createSupportTicket: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.conversationId}/support-ticket`,
        method: 'POST',
        body: option
      }),
      extraOptions: { showGlobalError: true }
    }),
    saveMessageFeedback: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Messages/${option.messageId}/Rating`,
        method: 'POST',
        body: option
      }),
      extraOptions: { showGlobalError: true }
    }),
    getMessageFeedbacks: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.conversationId}/Ratings`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    supportTicketExists: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.conversationId}/SupportTicketExist`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    isChatBotEnabled: builder.mutation({
      query: () => ({
        url: 'AiChatbot/IsChatBotEnabled',
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    endChat: builder.mutation({
      query: (option) => ({
        url: `AiChatbot/Conversations/${option.conversationId}/EndChat`,
        method: 'POST'
      }),
      extraOptions: { showGlobalError: true }
    })
  })
});

export const { 
  useGetActiveConversationMutation,
  useGetActiveConversationIdMutation,
  useGetMessagesMutation,
  useCreateConversationMutation,
  useAddMessageToConversationMutation,
  useCreateSupportTicketMutation,
  useSaveMessageFeedbackMutation,
  useGetMessageFeedbacksMutation,
  useSupportTicketExistsMutation,
  useIsChatBotEnabledMutation,
  useEndChatMutation
} = chatbotApi;
